module.exports = __webpack_public_path__ + "img/4598f39.png";